import { ReactComponent as CirclerIcon } from '../assets/icons/Icon.svg';
const generateConversation = (count) => {
    const conversation = [];

    for (let i = 0; i < count; i += 2) {
        const type = i % 3 === 0 ? 'sender' : 'receiver';
        const text = 'how can I help you today?';
        const imageURL =
            type === 'sender' ? (
                <CirclerIcon />
            ) : (
                //'https://anadearmas.net/photos/albums/Projects/DeepWater/Stills/normal_005.jpg'
                'http://anadearmas.net/images/potm.png'
            );

        conversation.push({
            id: i,
            text,
            type,
            imageURL,
        });
    }

    return conversation;
};

export const CHAT = generateConversation(1);

export const PANELS = [
    {
        id: 'panel1',
        heading: 'Travel Expense $550.00',
        // subHeading: 'I am an accordion',
        content:
            'Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat...Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat...Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat.',
    },
    {
        id: 'panel2',
        heading: 'Users',
        // subHeading: 'You are currently not an owner',
        content: 'Donec placerat, lectus sed mattis semper, neque lectus feugiat lectus...',
    },
    {
        id: 'panel3',
        heading: 'LAURA',
        // subHeading: 'You are currently not an owner',
        content: 'Donec placerat, lectus sed mattis semper, neque lectus feugiat lectus...',
    },
    // Add more panels as needed
];
export const DASHBOARD_PANELS = [
    {
        id: 'panel1',
        heading: 'Cost of Revenue',
        subHeading: '$44000',
        content:
            ' Nulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiatNulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiatNulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiatNulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiatNulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiatNulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiatNulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiatNulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiatNulla facilisi. Phasellus sollicitudin nulla et quam mattis feugiat...',
    },
    {
        id: 'panel2',
        heading: 'Operating Services',
        subHeading: 'You are currently not an owner',
        content: 'Donec placerat, lectus sed mattis semper, neque lectus feugiat lectus...',
    },
    {
        id: 'panel3',
        heading: 'Other Income',
        subHeading: 'You are currently not an owner',
        content: 'Donec placerat, lectus sed mattis semper, neque lectus feugiat lectus...',
    },
    // Add more panels as needed
];

// Sample data generation
const generateData = (count) => {
    const data = [];
    for (let i = 1; i <= count; i++) {
        data.push({
            id: i,
            number: i,
            name: `Person ${i}`,
            type: Math.floor(Math.random() * 50) + 20, // Random age between 20 and 70
            basis: `City ${i}`,
            description: 'Donec placerat, lectus sed mattis semper, neque lectus feugiat lectus...',
            memo: 'This account is used to record receivables from something.',
            isParentAccount: i % 5 === 0 ? true : false,
        });
    }
    return data;
};

export const sampleTableData = generateData(20);

export const TRANSACTION_ACCOUNTS = [
    { label: 'Cash', value: 1 },
    { label: 'Rent Expense', value: 2 },
    { label: 'Credit Card Payable', value: 3 },
    { label: 'Travel Expense', value: 4 },
];

// Sample data generation
const generateTransactionData = (count) => {
    const data = [];
    for (let i = 1; i <= count; i++) {
        data.push({
            id: i,
            date: `Jan 20, 202${i}`,
            transaction: i % 2 === 0 ? 'Airline Tickets' : 'Rent Expense',
            accountNo: [
                Math.floor(1000 + Math.random() * 9000),
                Math.floor(1000 + Math.random() * 9000),
            ], //Randomly generated 4 digit number
            amount: [`$${Math.floor(1000 + Math.random() * 9000)}`], //Randomly generated 4 digit number
            account: ['Travel Expense', 'Credit Card Payable'],
            debitCredit: [
                `$${Math.floor(Math.random() * (999 - 100 + 1) + 100).toFixed(2)}`,
                `$${Math.floor(Math.random() * (999 - 100 + 1) + 100).toFixed(2)}`,
            ],
            company: i % 2 === 0 ? 'Jet Blue' : 'Hilton',
            status: i % 2 === 0 ? 'Paid' : 'Unpaid',
            source: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
        });
    }
    return data;
};

export const sampleTransactionData = generateTransactionData(10);

export const TIMEZONES = [
    { label: 'New York (Eastern Time - EST/EDT)', value: 'America/New_York' },
    { label: 'Chicago (Central Time - CST/CDT)', value: 'America/Chicago' },
    { label: 'Denver (Mountain Time - MST/MDT)', value: 'America/Denver' },
    {
        label: 'Los Angeles (Pacific Time - PST/PDT)',
        value: 'America/Los_Angeles',
    },
    {
        label: 'Anchorage (Alaska Time - AKST/AKDT)',
        value: 'America/Anchorage',
    },
    {
        label: 'Honolulu (Hawaii-Aleutian Time - HST)',
        value: 'Pacific/Honolulu',
    },

    { label: 'Abidjan (GMT)', value: 'Africa/Abidjan' },
    { label: 'Cairo (EET)', value: 'Africa/Cairo' },
    { label: 'Johannesburg (SAST)', value: 'Africa/Johannesburg' },
    { label: 'Nairobi (EAT)', value: 'Africa/Nairobi' },
    { label: 'Lagos (WAT)', value: 'Africa/Lagos' },

    { label: 'São Paulo (BRT)', value: 'America/Sao_Paulo' },
    { label: 'Buenos Aires (ART)', value: 'America/Argentina/Buenos_Aires' },
    { label: 'Mexico City (CST)', value: 'America/Mexico_City' },
    { label: 'Bogotá (COT)', value: 'America/Bogota' },
    { label: 'Lima (PET)', value: 'America/Lima' },

    { label: 'Dubai (GST)', value: 'Asia/Dubai' },
    { label: 'Kolkata (IST)', value: 'Asia/Kolkata' },
    { label: 'Tokyo (JST)', value: 'Asia/Tokyo' },
    { label: 'Shanghai (CST)', value: 'Asia/Shanghai' },
    { label: 'Singapore (SGT)', value: 'Asia/Singapore' },
    { label: 'Jakarta (WIB)', value: 'Asia/Jakarta' },
    { label: 'Seoul (KST)', value: 'Asia/Seoul' },
    { label: 'Bangkok (ICT)', value: 'Asia/Bangkok' },

    { label: 'London (GMT)', value: 'Europe/London' },
    { label: 'Berlin (CET)', value: 'Europe/Berlin' },
    { label: 'Paris (CET)', value: 'Europe/Paris' },
    { label: 'Moscow (MSK)', value: 'Europe/Moscow' },
    { label: 'Rome (CET)', value: 'Europe/Rome' },
    { label: 'Madrid (CET)', value: 'Europe/Madrid' },

    { label: 'Sydney (AEST)', value: 'Australia/Sydney' },
    { label: 'Perth (AWST)', value: 'Australia/Perth' },
    { label: 'Auckland (NZST)', value: 'Pacific/Auckland' },
];

export const CURRENCIES = [
    { value: 'AED', label: 'UAE Dirham' },
    { value: 'AFN', label: 'Afghani' },
    { value: 'ALL', label: 'Lek' },
    { value: 'AMD', label: 'Armenian Dram' },
    { value: 'ANG', label: 'Netherlands Antillean Guilder' },
    { value: 'AOA', label: 'Kwanza' },
    { value: 'ARS', label: 'Argentine Peso' },
    { value: 'AUD', label: 'Australian Dollar' },
    { value: 'AWG', label: 'Aruban Florin' },
    { value: 'AZN', label: 'Azerbaijan Manat' },
    { value: 'BAM', label: 'Convertible Mark' },
    { value: 'BBD', label: 'Barbados Dollar' },
    { value: 'BDT', label: 'Taka' },
    { value: 'BGN', label: 'Bulgarian Lev' },
    { value: 'BHD', label: 'Bahraini Dinar' },
    { value: 'BIF', label: 'Burundi Franc' },
    { value: 'BMD', label: 'Bermudian Dollar' },
    { value: 'BND', label: 'Brunei Dollar' },
    { value: 'BOB', label: 'Boliviano' },
    { value: 'BOV', label: 'Mvdol' },
    { value: 'BRL', label: 'Brazilian Real' },
    { value: 'BSD', label: 'Bahamian Dollar' },
    { value: 'BTN', label: 'Ngultrum' },
    { value: 'BWP', label: 'Pula' },
    { value: 'BYN', label: 'Belarusian Ruble' },
    { value: 'BZD', label: 'Belize Dollar' },
    { value: 'CAD', label: 'Canadian Dollar' },
    { value: 'CDF', label: 'Congolese Franc' },
    { value: 'CHE', label: 'WIR Euro' },
    { value: 'CHF', label: 'Swiss Franc' },
    { value: 'CHW', label: 'WIR Franc' },
    { value: 'CLF', label: 'Unidad de Fomento' },
    { value: 'CLP', label: 'Chilean Peso' },
    { value: 'CNY', label: 'Yuan Renminbi' },
    { value: 'COP', label: 'Colombian Peso' },
    { value: 'COU', label: 'Unidad de Valor Real' },
    { value: 'CRC', label: 'Costa Rican Colon' },
    { value: 'CUC', label: 'Peso Convertible' },
    { value: 'CUP', label: 'Cuban Peso' },
    { value: 'CVE', label: 'Cabo Verde Escudo' },
    { value: 'CZK', label: 'Czech Koruna' },
    { value: 'DJF', label: 'Djibouti Franc' },
    { value: 'DKK', label: 'Danish Krone' },
    { value: 'DOP', label: 'Dominican Peso' },
    { value: 'DZD', label: 'Algerian Dinar' },
    { value: 'EGP', label: 'Egyptian Pound' },
    { value: 'ERN', label: 'Nakfa' },
    { value: 'ETB', label: 'Ethiopian Birr' },
    { value: 'EUR', label: 'Euro' },
    { value: 'FJD', label: 'Fiji Dollar' },
    { value: 'FKP', label: 'Falkland Islands Pound' },
    { value: 'GBP', label: 'Pound Sterling' },
    { value: 'GEL', label: 'Lari' },
    { value: 'GHS', label: 'Ghana Cedi' },
    { value: 'GIP', label: 'Gibraltar Pound' },
    { value: 'GMD', label: 'Dalasi' },
    { value: 'GNF', label: 'Guinean Franc' },
    { value: 'GTQ', label: 'Quetzal' },
    { value: 'GYD', label: 'Guyana Dollar' },
    { value: 'HKD', label: 'Hong Kong Dollar' },
    { value: 'HNL', label: 'Lempira' },
    { value: 'HTG', label: 'Gourde' },
    { value: 'HUF', label: 'Forint' },
    { value: 'IDR', label: 'Rupiah' },
    { value: 'ILS', label: 'New Israeli Sheqel' },
    { value: 'INR', label: 'Indian Rupee' },
    { value: 'IQD', label: 'Iraqi Dinar' },
    { value: 'IRR', label: 'Iranian Rial' },
    { value: 'ISK', label: 'Iceland Krona' },
    { value: 'JMD', label: 'Jamaican Dollar' },
    { value: 'JOD', label: 'Jordanian Dinar' },
    { value: 'JPY', label: 'Yen' },
    { value: 'KES', label: 'Kenyan Shilling' },
    { value: 'KGS', label: 'Som' },
    { value: 'KHR', label: 'Riel' },
    { value: 'KMF', label: 'Comorian Franc' },
    { value: 'KPW', label: 'North Korean Won' },
    { value: 'KRW', label: 'Won' },
    { value: 'KWD', label: 'Kuwaiti Dinar' },
    { value: 'KYD', label: 'Cayman Islands Dollar' },
    { value: 'KZT', label: 'Tenge' },
    { value: 'LAK', label: 'Lao Kip' },
    { value: 'LBP', label: 'Lebanese Pound' },
    { value: 'LKR', label: 'Sri Lanka Rupee' },
    { value: 'LRD', label: 'Liberian Dollar' },
    { value: 'LSL', label: 'Loti' },
    { value: 'LYD', label: 'Libyan Dinar' },
    { value: 'MAD', label: 'Moroccan Dirham' },
    { value: 'MDL', label: 'Moldovan Leu' },
    { value: 'MGA', label: 'Malagasy Ariary' },
    { value: 'MKD', label: 'Denar' },
    { value: 'MMK', label: 'Kyat' },
    { value: 'MNT', label: 'Tugrik' },
    { value: 'MOP', label: 'Pataca' },
    { value: 'MRU', label: 'Ouguiya' },
    { value: 'MUR', label: 'Mauritius Rupee' },
    { value: 'MVR', label: 'Rufiyaa' },
    { value: 'MWK', label: 'Malawi Kwacha' },
    { value: 'MXN', label: 'Mexican Peso' },
    { value: 'MXV', label: 'Mexican Unidad de Inversion (UDI)' },
    { value: 'MYR', label: 'Malaysian Ringgit' },
    { value: 'MZN', label: 'Mozambique Metical' },
    { value: 'NAD', label: 'Namibia Dollar' },
    { value: 'NGN', label: 'Naira' },
    { value: 'NIO', label: 'Cordoba Oro' },
    { value: 'NOK', label: 'Norwegian Krone' },
    { value: 'NPR', label: 'Nepalese Rupee' },
    { value: 'NZD', label: 'New Zealand Dollar' },
    { value: 'OMR', label: 'Rial Omani' },
    { value: 'PAB', label: 'Balboa' },
    { value: 'PEN', label: 'Sol' },
    { value: 'PGK', label: 'Kina' },
    { value: 'PHP', label: 'Philippine Peso' },
    { value: 'PKR', label: 'Pakistan Rupee' },
    { value: 'PLN', label: 'Zloty' },
    { value: 'PYG', label: 'Guarani' },
    { value: 'QAR', label: 'Qatari Rial' },
    { value: 'RON', label: 'Romanian Leu' },
    { value: 'RSD', label: 'Serbian Dinar' },
    { value: 'RUB', label: 'Russian Ruble' },
    { value: 'RWF', label: 'Rwanda Franc' },
    { value: 'SAR', label: 'Saudi Riyal' },
    { value: 'SBD', label: 'Solomon Islands Dollar' },
    { value: 'SCR', label: 'Seychelles Rupee' },
    { value: 'SDG', label: 'Sudanese Pound' },
    { value: 'SEK', label: 'Swedish Krona' },
    { value: 'SGD', label: 'Singapore Dollar' },
    { value: 'SHP', label: 'Saint Helena Pound' },
    { value: 'SLE', label: 'Leone' },
    { value: 'SOS', label: 'Somali Shilling' },
    { value: 'SRD', label: 'Surinam Dollar' },
    { value: 'SSP', label: 'South Sudanese Pound' },
    { value: 'STN', label: 'Dobra' },
    { value: 'SVC', label: 'El Salvador Colon' },
    { value: 'SYP', label: 'Syrian Pound' },
    { value: 'SZL', label: 'Lilangeni' },
    { value: 'THB', label: 'Baht' },
    { value: 'TJS', label: 'Somoni' },
    { value: 'TMT', label: 'Turkmenistan New Manat' },
    { value: 'TND', label: 'Tunisian Dinar' },
    { value: 'TOP', label: 'Pa’anga' },
    { value: 'TRY', label: 'Turkish Lira' },
    { value: 'TTD', label: 'Trinidad and Tobago Dollar' },
    { value: 'TWD', label: 'New Taiwan Dollar' },
    { value: 'TZS', label: 'Tanzanian Shilling' },
    { value: 'UAH', label: 'Hryvnia' },
    { value: 'UGX', label: 'Uganda Shilling' },
    { value: 'USD', label: 'US Dollar' },
    { value: 'USN', label: 'US Dollar (Next day)' },
    { value: 'UYI', label: 'Uruguay Peso en Unidades Indexadas (UI)' },
    { value: 'UYU', label: 'Peso Uruguayo' },
    { value: 'UYW', label: 'Unidad Previsional' },
    { value: 'UZS', label: 'Uzbekistan Sum' },
    { value: 'VED', label: 'Bolívar Soberano' },
    { value: 'VES', label: 'Bolívar Soberano' },
    { value: 'VND', label: 'Dong' },
    { value: 'VUV', label: 'Vatu' },
    { value: 'WST', label: 'Tala' },
    { value: 'XAF', label: 'CFA Franc BEAC' },
    { value: 'XCD', label: 'East Caribbean Dollar' },
    { value: 'XDR', label: 'SDR (Special Drawing Right)' },
    { value: 'XOF', label: 'CFA Franc BCEAO' },
    { value: 'XPF', label: 'CFP Franc' },
    { value: 'XSU', label: 'Sucre' },
    { value: 'XUA', label: 'ADB Unit of Account' },
    { value: 'YER', label: 'Yemeni Rial' },
    { value: 'ZAR', label: 'Rand' },
    { value: 'ZMW', label: 'Zambian Kwacha' },
    { value: 'ZWL', label: 'Zimbabwe Dollar' },
];
